import * as React from 'react'
import Box from '@mui/material/Box'
import Collapse from '@mui/material/Collapse'
import IconButton from '@mui/material/IconButton'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableSortLabel from '@mui/material/TableSortLabel'
import Paper from '@mui/material/Paper'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { useTranslation } from "react-i18next"
import { Tooltip, FormControlLabel, Switch, Button, Popper } from '@mui/material'
import { useNavigate, useLocation } from 'react-router-dom'
import TablePagination from "@mui/material/TablePagination";
import { t } from 'i18next'
import dayjs from 'dayjs'
import { useState } from 'react'
import VerticalAlignTopIcon from '@mui/icons-material/VerticalAlignTop';
import AssignForklifter from './sales_purchase_orders/AssignForklifter'
import { visuallyHidden } from '@mui/utils';
import { getComparator, stableSort } from '../helpers/DailyBoardTableHelpers'
import { useStateContext } from '../context/ContextProvider'
import MoveSite from './sales_purchase_orders/MoveSite'

function Row(props) {
    const { row, user, setIsLoading, showDate } = props;
    const [open, setOpen] = React.useState(false)

    return (
        <React.Fragment >
            <TableRow sx={{ '& > *': { borderBottom: 'unset !important' } }}>
                <TableCell sx={{ padding: '8px 16px', position: 'relative', fontWeight: '500' }}>
                    {
                        row.type == 'CUSTOMER PICKUP' ?
                            <Tooltip disableInteractive title={t('customer_pickup')}>
                                <div style={{ position: 'absolute', top: 0, left: 0, border: '7.5px solid', borderColor: `rgb(211, 211, 30) transparent transparent rgb(211, 211, 30)` }}></div>
                            </Tooltip>
                            :
                            null
                    }
                    {
                        row.type == '3PL' ?
                            <Tooltip disableInteractive title={t('3PL')}>
                                <div style={{ position: 'absolute', top: 0, left: 0, border: '7.5px solid', borderColor: `rgb(76, 175, 80) transparent transparent rgb(76, 175, 80)` }}></div>
                            </Tooltip>
                            :
                            null
                    }
                    {
                        row.type == 'BROKERED' ?
                            <Tooltip disableInteractive title={t('brokered')}>
                                <div style={{ position: 'absolute', top: 0, left: 0, border: '7.5px solid', borderColor: `rgb(255,25,25) transparent transparent rgb(255,25,25)` }}></div>
                            </Tooltip>
                            :
                            null
                    }
                    {row.so_number}
                </TableCell>
                <TableCell sx={{ padding: '8px 16px', fontStyle: 'italic' }}>{row.customer_name}</TableCell>
                {showDate == 'shipment_date' ? (
                    <TableCell sx={{ padding: '8px 16px' }}>{<ShowDate date={row.shipment_date} />}</TableCell>
                ) : (
                    <TableCell sx={{ padding: '8px 16px' }}>{<ShowDate date={row.requested_delivery_date} />}</TableCell>
                )}
                <TableCell sx={{ padding: '8px 16px' }}>
                    {
                        <Status status={row.so_status_id} forklifter={row.forklift_driver_name} status_name={row.so_status_name} driver={row.driver_name} />
                    }
                </TableCell>
                <TableCell sx={{ padding: '8px 5px' }}>
                    {
                        <TodaysSalesOrderAction row={row} id={row.id} siteId={row?.site_id} brokerTransactionId={row?.broker_transaction?.id} accessCode={row.service_provider_access_code} status={row.so_status_id} statusSlug={row.so_status} statusName={row.so_status_name} prevStatusSlug={row.prev_status?.key} prevStatusName={row.prev_status?.name} forklifter={{ id: row.forklift_driver_id, name: row.forklift_driver_name }} type={row.type} deletedAt={row.deleted_at} user={user} setIsLoading={setIsLoading}/>
                    }
                </TableCell>
                <TableCell sx={{ padding: '8px 16px' }}>
                    <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
            </TableRow>
            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                <TableCell style={{ padding: 0 }} colSpan={7}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box>
                            <Table size="small" aria-label="sales-order-items">
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ width: '20%' }}>{t('item_no')}</TableCell>
                                        <TableCell sx={{ width: '50%' }}>{t('description')}</TableCell>
                                        <TableCell sx={{ width: '10%' }}>{t('quantity_ordered')}</TableCell>
                                        <TableCell sx={{ width: '10%' }}>{t('quantity_to_ship')}</TableCell>
                                        <TableCell sx={{ width: '10%' }}>{t('quantity_shipped')}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {row.sales_order_items.map((historyRow) => (
                                        <TableRow key={historyRow.id}>
                                            <TableCell sx={{ padding: '8px 16px' }}>{historyRow.item_no}</TableCell>
                                            <TableCell sx={{ padding: '8px 16px' }}>{historyRow.description}</TableCell>
                                            <TableCell sx={{ padding: '8px 16px' }}>{historyRow.qty_ordered}</TableCell>
                                            <TableCell sx={{ padding: '8px 16px' }}>{historyRow.qty_to_ship}</TableCell>
                                            <TableCell sx={{ padding: '8px 16px' }}>{historyRow.qty_shipped}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>

        </React.Fragment>
    );
}

const SortableTableHeaderRow = (props) => {
    const { order, orderBy, onRequestSort, showDate } = props
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property)
    }

    return (

        <TableHead>

            <TableRow>
                {/* Sales Order No. cell */}
                <TableCell
                    sortDirection={orderBy === 'so_number' ? order : false}>
                    <TableSortLabel sx={{ color: '#88909C !important', fontWeight: '400' }}
                        active={orderBy === 'so_number'}
                        direction={orderBy === 'so_number' ? order : 'asc'}
                        onClick={createSortHandler('so_number')}>
                        {t('sales_order_no')}
                        {orderBy === 'so_number' ? (
                            <Box component="span" sx={visuallyHidden}>
                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </Box>
                        ) : null}
                    </TableSortLabel>
                </TableCell>
                {/* Customer Name cell */}
                <TableCell
                    sortDirection={orderBy === 'customer_name' ? order : false}>
                    <TableSortLabel sx={{ color: '#88909C !important', fontWeight: '400' }}
                        active={orderBy === 'customer_name'}
                        direction={orderBy === 'customer_name' ? order : 'asc'}
                        onClick={createSortHandler('customer_name')}>
                        {t('customer')}
                        {orderBy === 'customer_name' ? (
                            <Box component="span" sx={visuallyHidden}>
                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </Box>
                        ) : null}
                    </TableSortLabel>
                </TableCell>

                {showDate == 'shipment_date' ? (
                    // Shipment Date
                    <TableCell
                        sortDirection={orderBy === 'shipment_date' ? order : false}
                    >
                        <TableSortLabel sx={{ color: '#88909C !important', fontWeight: '400' }}
                            active={orderBy === 'shipment_date'}
                            direction={orderBy === 'shipment_date' ? order : 'asc'}
                            onClick={createSortHandler('shipment_date')}>
                            {t('shipment_date')}
                            {orderBy === 'shipment_date' ? (
                                <Box component="span" sx={visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </Box>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ) : (
                    // Requested Delivery Date
                    <TableCell
                        sortDirection={orderBy === 'requested_delivery_date' ? order : false}
                    >
                        <TableSortLabel sx={{ color: '#88909C !important', fontWeight: '400' }}
                            active={orderBy === 'requested_delivery_date'}
                            direction={orderBy === 'requested_delivery_date' ? order : 'asc'}
                            onClick={createSortHandler('requested_delivery_date')}>
                            {t('requested_delivery_date')}
                            {orderBy === 'requested_delivery_date' ? (
                                <Box component="span" sx={visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </Box>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                )}

                {/* Status cell */}
                <TableCell
                    sortDirection={orderBy === 'so_status' ? order : false}>
                    <TableSortLabel sx={{ color: '#88909C !important', fontWeight: '400' }}
                        active={orderBy === 'so_status'}
                        direction={orderBy === 'so_status' ? order : 'asc'}
                        onClick={createSortHandler('so_status')}>
                        {t('status')}
                        {orderBy === 'so_status' ? (
                            <Box component="span" sx={visuallyHidden}>
                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </Box>
                        ) : null}
                    </TableSortLabel>
                </TableCell>
                <TableCell sx={{ color: '#88909C !important', fontWeight: '400' }}>{t('actions')}</TableCell>
                <TableCell />
            </TableRow>
        </TableHead>
    )
}

export default function CollapsibleTable({ items, total, user, page = 1, rowsPerPage = 10, opc = undefined, orppc = undefined, osc = undefined, showDate = 'requested_delivery_date' }) {

    const { t } = useTranslation()

    const pg = Number(page - 1)
    const rpg = Number(rowsPerPage)

    const [orderBy, setOrderBy] = useState('created_at')
    const [order, setOrder] = useState('desc')

    function handleChangePage(event, newpage) {
        if(opc) {
            opc(Number(newpage + 1));
        }
    }

    function handleChangeRowsPerPage(event) {
        if(orppc) {
            opc(1);
            orppc(parseInt(event.target.value, 10));
        }
    }

    const handleRequestSort = (event, property) => {
        if (order === 'desc' && orderBy === property) {
            setOrderBy('created_at')
            if(osc) {
                osc('created_at,desc')
            }
        } else {
            const isAsc = orderBy === property && order === 'asc'
            setOrder(isAsc ? 'desc' : 'asc')
            setOrderBy(property)
            if(osc) {
                osc(`${property},${isAsc ? 'desc' : 'asc'}`)
            }
        }
    }

    return (
        <div>
            <div style={{ width: '100%', mb: 2, border: 'none' }}>
                <TableContainer>
                    <Table aria-label="collapsible table" stickyHeader>
                        <colgroup>
                            <col width="15%" />
                            <col width="15%" />
                            <col width="25%" />
                            <col width="25%" />
                            <col width="10%" />
                            <col />
                        </colgroup>
                        <SortableTableHeaderRow
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={handleRequestSort}
                            showDate={showDate}
                        />
                        <TableBody>
                            {items.length <= 0 ? <TableRow><TableCell colSpan={6} sx={{ textAlign: 'center' }}>{t('no_data')}</TableCell></TableRow> : null}
                            {items?.map((row) => (
                                <Row key={row.id} row={row} user={user} showDate={showDate} />
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    className='table-pagination'
                    labelRowsPerPage={t('rowsPerPage')}
                    rowsPerPageOptions={[10, 15]}
                    component="div"
                    count={total}
                    rowsPerPage={rpg}
                    page={pg}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </div>
        </div>
    );
}

const Status = ({ status, status_name, forklifter, driver }) => {

    return (
        <>
            {
                status == 4 ?
                    forklifter ?
                        <Tooltip disableInteractive title={forklifter} placement='bottom'>
                            <div className='w-full bg-[#FFF0B6] rounded-md p-1 text-center text-[#8A5001] font-[500]'>{status_name}</div>
                        </Tooltip>
                        :
                        <div className='w-full bg-[#FFF0B6] rounded-md p-1 text-center text-[#8A5001] font-[500]'>{status_name}</div>
                    :
                    status == 7 ?
                        driver ?
                            <Tooltip disableInteractive title={driver} placement='bottom'>
                                <div className='w-full bg-[#FFE4B9] rounded-md p-1 text-center text-[#804E00] font-[500]'>{status_name}</div>
                            </Tooltip>
                            :
                            <div className='w-full bg-[#FFE4B9] rounded-md p-1 text-center text-[#804E00] font-[500]'>{status_name}</div>
                        :
                        status == 1 ?
                            <div className='w-full bg-[#D2ECFE] rounded-md p-1 text-[#0073C1] text-center font-[500]'>{status_name}</div>
                            :
                            status == 2 ?
                                <div className='w-full bg-[#FFD48F] rounded-md p-1 text-[#9D6000] text-center font-[500]'>{status_name}</div>
                                :
                                status == 3 ?
                                    <div className='w-full bg-[#D2ECFE] rounded-md p-1 text-[#0073C1] text-center font-[500]'>{status_name}</div>
                                    :
                                    status == 5 ?
                                        <div className='w-full bg-[#FDFF8D] rounded-md p-1 text-[#BB7B00] text-center font-[500]'>{status_name}</div>
                                        :
                                        status == 6 ?
                                            <div className='w-full bg-[#FFED8D] rounded-md p-1 text-[#B16103] text-center font-[500]'>{status_name}</div>
                                            :
                                            status == 8 ?
                                                <div className='w-full bg-[#D5EDFB] rounded-md p-1 text-[#008A93] text-center font-[500]'>{status_name}</div>
                                                :
                                                status == 9 ?
                                                    <div className='w-full bg-[#BEFFD6] rounded-md p-1 text-[#017C40] text-center font-[500]'>{status_name}</div>
                                                    :
                                                    status == 10 ?
                                                        <div className='w-full bg-[#E8E8E8] rounded-md p-1 text-[#515151] text-center font-[500]'>{status_name}</div>
                                                        :
                                                        status == 11 ?
                                                            <div className='w-full bg-[#BEFFD6] rounded-md p-1 text-[#017C40] text-center font-[500]'>{status_name}</div>
                                                            :
                                                            status == 12 ?
                                                                <div className='w-full bg-[#FFD1D1] rounded-md p-1 text-[#B81100] text-center font-[500]'>{status_name}</div>
                                                                :
                                                                ''
            }
        </>
    )
}

const TodaysSalesOrderAction = ({ row, id, siteId, brokerTransactionId = null, accessCode, status, statusSlug, statusName, prevStatusSlug, prevStatusName, forklifter, type, deletedAt, user, setIsLoading }) => {

    const { t } = useTranslation()
    const navigate = useNavigate()
    const location = useLocation()

    const [open, setOpen] = useState(false)

    const openPopup = () => {
        setOpen(!open)
    }

    const userHasPermissions = (targets = []) => {
        return user?.permissions.some((permission) => targets.includes(permission.name))
    }

    const { allSites } = useStateContext()
    const sites = allSites?.filter((site) => site.company_id == localStorage.getItem('company_id'));
    const [openMoveSite, setOpenMoveSite] = useState(false);

    const moveSiteBlockedBy = ['loading', 'in_transit'].includes(statusSlug) ? statusName : null
    const delicatePreviousStatus = (['loading', 'in_transit'].includes(prevStatusSlug) && ['reopened'].includes(statusSlug)) ? prevStatusName : null;

    return (
        <>
            <div className='flex gap-1'>
                <Tooltip disableInteractive title="BOL/POD" placement='bottom'>
                    <div style={{ color: 'rgba(0,0,0,.54)' }}>
                        <a href={process.env.REACT_APP_BACKEND_URL + `/api/${['vendor_user', 'service_provider_user'].includes(user?.role) ? ('broker-transactions/' + brokerTransactionId) : ('sales-orders/' + id)}/proof-of-delivery?stream=view&party=${['vendor_user', 'service_provider_user'].includes(user?.role) ? 'supplier' : 'customer'}&CLIENT_ID=${localStorage.getItem('client_id')}&CLIENT_TIMEZONE=${encodeURIComponent(localStorage.getItem('client_timezone'))}`} target="_blank"><span style={{ cursor: 'pointer' }} className="flex justify-center items-center hover:rounded-full icons p-2 hover:bg-zinc-200"><i className="fa-solid fa-print"></i></span></a>
                    </div>
                </Tooltip>

                {
                    (
                        (
                            ['master_admin', 'office_manager'].includes(user?.role)
                            || userHasPermissions(['daily-board-update'])
                        )
                        && (
                            status === 1
                            || status === 3
                        )
                    ) ? (
                        <Tooltip disableInteractive title={t('update')} placement='bottom'>
                            <div style={{ color: 'rgba(0,0,0,.54)' }}>
                                <button onClick={() => navigate(`${id}`, { state: { prevPathname: location.pathname } })}><span style={{ cursor: 'pointer' }} className="flex justify-center items-center hover:rounded-full icons p-2 hover:bg-zinc-200"><i className="fa-solid fa-pencil"></i></span></button>
                            </div>
                        </Tooltip>
                    ) : (
                        <Tooltip disableInteractive title={t('open')} placement='bottom'>
                            <div style={{ color: 'rgba(0,0,0,.54)' }}>
                                <button onClick={() => navigate(
                                    (['vendor_user', 'service_provider_user'].includes(user?.role) && brokerTransactionId) ? `${brokerTransactionId}` : `${id}`,
                                    {
                                        state: {
                                            prevPathname: location.pathname
                                        }
                                    }
                                )}><span style={{ cursor: 'pointer' }} className="flex justify-center items-center hover:rounded-full icons p-2 hover:bg-zinc-200"><i className="fa-solid fa-eye"></i></span></button>
                            </div>
                        </Tooltip>
                    )
                }

                {(['master_admin', 'office_manager'].includes(user?.role)) && (status === 2 || status === 4) ?
                    (
                        type != 'CUSTOMER PICKUP' ?
                            <Tooltip disableInteractive title={t('assign_forklifter')} placement='bottom'>
                                <div style={{ color: 'rgba(0,0,0,.54)' }}>
                                    <span style={{ cursor: 'pointer' }} onClick={openPopup} className="flex justify-center items-center hover:rounded-full icons p-2 hover:bg-zinc-200"><VerticalAlignTopIcon /></span>
                                </div>
                            </Tooltip>
                            :
                            null
                    )
                    :
                    ''
                }

                {
                    (
                        ['vendor_user', 'service_provider_user'].includes(user?.role)
                        && accessCode
                        && localStorage.getItem('impersonate') === null
                    ) ? (
                        <Tooltip disableInteractive title={t('view_as_driver')} placement='bottom'>
                            <div style={{ color: 'rgba(0,0,0,.54)' }}>
                                <button onClick={() => navigate(`/broker-sales?code=${accessCode}`)}><span style={{ cursor: 'pointer' }} className="flex justify-center items-center hover:rounded-full icons p-2 hover:bg-zinc-200"><i className="fa-solid fa-truck"></i></span></button>
                            </div>
                        </Tooltip>
                    ) : null
                }

                {
                    (['master_admin', 'office_manager'].includes(user?.role) && sites.length > 1 && !deletedAt) && (
                        <Tooltip
                            disableInteractive
                            title={moveSiteBlockedBy
                                ? t('cannot_move_site_while_x', { x: moveSiteBlockedBy })
                                : delicatePreviousStatus
                                    ? "Cannot move sites while the order is being processed or has been reopened for editing"
                                    : t('move_site')
                            }
                            placement='bottom'
                        >
                            <div style={{ color: 'rgba(0,0,0,.54)' }}>
                                <span
                                    style={{ cursor: (moveSiteBlockedBy || delicatePreviousStatus) ? 'not-allowed' : 'pointer', opacity: (moveSiteBlockedBy || delicatePreviousStatus) ? 0.4 : 1 }}
                                    className="flex justify-center items-center hover:rounded-full icons p-2 hover:bg-zinc-200"
                                    onClick={(e) => { if(!(moveSiteBlockedBy || delicatePreviousStatus)) { setOpenMoveSite(true) } }}
                                ><i className="fa-solid fa-building-circle-arrow-right"></i></span>
                            </div>
                        </Tooltip>
                    )
                }
            </div>
            <AssignForklifter open={open} setOpen={setOpen} orderId={id} siteId={siteId} _forklifter={forklifter} type={"sales"} setIsLoading={setIsLoading} />
            <MoveSite
                open={openMoveSite}
                setOpen={setOpenMoveSite}
                id={id}
                _siteId={siteId}
                type="sales"
                sites={sites}
            />
        </>
    )
}

export const ShowDate = ({ date }) => {

    const date1 = new Date(dayjs(date).format("YYYY-MM-DD"))
    const date2 = new Date(dayjs().format("YYYY-MM-DD"))

    return (
        <div>
            {
                date1 < date2 ? <p style={{ color: '#F00', padding: '5px', lineHeight: '1', width: 'fit-content' }}>{dayjs(date).format("MMMM D, YYYY")}</p> :
                    date1 == date2 ? <p style={{ color: 'blue', padding: '5px', lineHeight: '1', width: 'fit-content' }}>{dayjs(date).format("MMMM D, YYYY")}</p> :
                        date1 > date2 ? <p style={{ color: '#008E00', padding: '5px', lineHeight: '1', width: 'fit-content' }}>{dayjs(date).format("MMMM D, YYYY")}</p> :
                            <p style={{ color: 'blue', padding: '5px', lineHeight: '1', width: 'fit-content' }}>{dayjs(date).format("MMMM D, YYYY")}</p>
            }
        </div>
    )
}
